import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Jaw } from '@libs/ui-lib';
import { PerioPositionIndicatorToothComponent } from '../perio-position-indicator-tooth/perio-position-indicator-tooth.component';
import { PerioTooltipToothSurface } from '../perio-exam-toolbar/perio-exam-toolbar.interface';
import { PerioTooltipToothSide } from './perio-position-indicator-side.interface';

@Component({
  selector: 'lib-perio-position-indicator-side',
  imports: [CommonModule, PerioPositionIndicatorToothComponent],
  templateUrl: './perio-position-indicator-side.component.html',
  styleUrl: './perio-position-indicator-side.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioPositionIndicatorSideComponent {
  public side = input.required<PerioTooltipToothSide>();
  public jaw = input.required<Jaw>();
  public toothClick = output<PerioTooltipToothSurface>();

  protected teeth = computed(() => this.side().teeth);

  protected isActive = computed(() => {
    const side = this.side();

    if (!side) return false;

    return this.hasActiveTooth(this.teeth());
  });

  protected classList = computed(() => ({
    active: this.isActive(),
    'flex-col': this.jaw() === 'upper',
    'flex-col-reverse': this.jaw() === 'lower',
  }));

  protected onToothClick(tooth: PerioTooltipToothSurface): void {
    this.toothClick.emit(tooth);
  }

  private hasActiveTooth(toothList: PerioTooltipToothSurface[]): boolean {
    return toothList.some((tooth) => tooth.status === 'active');
  }
}
